import type { Transition } from "@uirouter/core";

import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";

import { EKeywordCompetitorsPageTabs } from "../website-analysis/pages/search-competitors/KeywordCompetitorsPage";

const canonicalSelectedPageTab = EKeywordCompetitorsPageTabs[
    EKeywordCompetitorsPageTabs.Organic
] as string;

/**
 * Keyword Research competitors no longer has Organic/Paid tabs; normalize legacy URLs.
 */
export const onRedirectKeywordCompetitorsPageTab: transitionHookFn = (transition: Transition) => {
    const toParams = transition.params("to");
    const selectedPageTab = toParams?.selectedPageTab;

    if (selectedPageTab == null || selectedPageTab === "") {
        return;
    }
    if (selectedPageTab === canonicalSelectedPageTab) {
        return;
    }
    return {
        params: {
            ...toParams,
            selectedPageTab: canonicalSelectedPageTab,
        },
    };
};
